import { render, staticRenderFns } from "./PolandFlagSVG.vue?vue&type=template&id=31a0a7a8&scoped=true&"
import script from "./PolandFlagSVG.vue?vue&type=script&lang=js&"
export * from "./PolandFlagSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0a7a8",
  null
  
)

export default component.exports